import { apiPost, apiGet } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import { showFailure } from 'actions/notificationActions';
import {
  FETCH_PROPERTIES,
  FETCH_PROPERTY_FILTERS,
  FETCH_PROPERTIES_FOR_REVIEW,
} from './actionTypes';

export function getPropertiesForMultiselect(options = {}) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/landlords/properties/search`;
    return dispatch({
      type: FETCH_PROPERTIES,
      payload: apiPost(url, options).catch(error => {
        dispatch(showFailure(error));
      }),
    });
  };
}

export function getPropertyFiltersForMultiselect() {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/landlords/properties/filters`;
    return dispatch({
      type: FETCH_PROPERTY_FILTERS,
      payload: apiGet(url).catch(error => {
        dispatch(showFailure(error));
      }),
    });
  };
}

export function getPropertiesForReview(options = {}) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/landlords/properties/review`;
    return dispatch({
      type: FETCH_PROPERTIES_FOR_REVIEW,
      payload: apiPost(url, options).catch(error => {
        dispatch(showFailure(error));
      }),
    });
  };
}
